module.exports = __webpack_public_path__ + "static/about_banner-3c6bebb40f2f7da84173732fba2236fb.png";